import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute(
  '/_layout/products/agentic-system-development/',
)({
  head: () => buildHead('/products/agentic-system-development'),
});
